import styled from "styled-components";
import { COLOR_RED } from "../../constants/color";

type PreviewInputProps = {
  name: string;
  label?: string;
  value?: string;
  fullWidth?: boolean;
  className?: string;
};

export const PreviewInput: React.FC<PreviewInputProps> = ({
  name,
  label,
  value,
  fullWidth,
  className,
}) => {
  return (
    <StyledContainer $fullWidth={fullWidth} className={className}>
      <StyledHeader>
        {label && (
          <StyledLabel>
            {label}
          </StyledLabel>
        )}
      </StyledHeader>

      <StyledValueContainer>
        <StyledValue>{value || "—"}</StyledValue>
      </StyledValueContainer>
    </StyledContainer>
  );
};

const StyledContainer = styled.div<{ $fullWidth?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 6px;
  ${({ $fullWidth }) => $fullWidth && "width: 100%;"}
`;

const StyledHeader = styled.div`
  display: flex;
  align-items: center;
`;

const StyledLabel = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 100%;
  margin-right: 5px;
`;

const StyledValueContainer = styled.div<{ $hasError?: boolean }>`
  padding: 17px 16px;
  border-radius: 6px;
  border: 1px solid #cccccc;
  background-color: #f9f9f9;
  box-sizing: border-box;
`;

const StyledValue = styled.div`
  font-size: 14px;
  line-height: 100%;
  color: #333333;
`;
